import { GridApi, GridOptions, createGrid } from 'ag-grid-community';
import { PermissionObject } from '../RolePanelTypes';

export class PermissionObjectsGrid {
    public api: GridApi<PermissionObject>;
    private readonly containerEl: HTMLElement;
    constructor(containerEl: HTMLElement) {
        this.containerEl = containerEl;
    }

    public async init(): Promise<void> {
        const response = await fetch('/rolePanel/permissionObjects');
        const data: PermissionObject[] = await response.json();
        const gridOptions: GridOptions = {
            rowData: data,
            columnDefs: [{ field: 'Name', headerName: 'Permission Objects', flex: 1, resizable: false }],
            rowSelection: 'single',
            suppressCellFocus: true,
            onFirstDataRendered: (params) => params.api.getDisplayedRowAtIndex(0).setSelected(true),
        };

        this.api = createGrid(this.containerEl, gridOptions);
        const firstDataRender = new Promise<void>((resolve) => {
            this.api.addEventListener('firstDataRendered', () => {
                resolve();
            });
        });
        await firstDataRender;
    }
}
